import { useQuery } from '@tanstack/vue-query'
import gql from 'graphql-tag'
import { RecyclerResponseStatus } from '~/types/graphql-backend-types/gql-types'

export function useRecyclerWelcomeScreenPendingResponse() {
  const { query } = useGqlMikro()

  return useQuery({
    queryKey: ['recycler-responses'],
    queryFn: async () => {
      const { data, errors } = await query({
        query: RECYCLER_PENDING_RESPONSE_QUERY,
        variables: {
          pagination: {
            limit: 10,
            offset: (toValue(1) - 1) * 10,
          },
          filters: { status: [RecyclerResponseStatus.Pending] },
        },
      })

      if (errors && errors.length > 0) {
        throw new Error(errors[0].message)
      }

      return data.recyclerResponsesByClientId
    },
  })
}

const RECYCLER_PENDING_RESPONSE_QUERY = gql`
query RecyclerPendingResponses($filters: RecyclerResponseFiltersGraphql) {
  recyclerResponsesByClientId(filters: $filters) {
    count
    collection {
      status
      id
      request {
        id
        materialName
        description
      }
    }
  }
}
`
